export type BillingState = {
  id: string;
  name: string;
  active: boolean;
  subscriptionPlan: string;
  subscriptionStatus: string;
  billingCycle: string;
  subscriptionPrice?: number | null;
  stripeCustomerId?: string | null;
  stripeSubscriptionId?: string | null;
  stripePriceId?: string | null;
  stripeCurrentPeriodEnd?: string | null;
  trialEndsAt?: string | null;
  nextBillingAt?: string | null;
};

export const subscriptionLabel: Record<string, string> = {
  BASIC: 'Basic',
  PRO: 'Pro',
  ENTERPRISE: 'Enterprise',
};

export const statusLabel: Record<string, string> = {
  TRIALING: 'Em trial',
  ACTIVE: 'Ativa',
  PAST_DUE: 'Pagamento pendente',
  CANCELED: 'Cancelada',
};

export const cycleLabel: Record<string, string> = {
  MONTHLY: 'Mensal',
  YEARLY: 'Anual',
};

export const isBillingOperational = (billing?: Pick<BillingState, 'active' | 'subscriptionStatus' | 'trialEndsAt'> | null) => {
  if (!billing?.active) return false;
  if (billing.subscriptionStatus === 'ACTIVE') return true;

  if (billing.subscriptionStatus === 'TRIALING') {
    if (!billing.trialEndsAt) return true;
    return new Date(billing.trialEndsAt).getTime() >= Date.now();
  }

  return false;
};
